export const BUILD_VERSION = process.env.REACT_APP_BUILD_VERSION || 'dev';
export const BUILD_TIME = process.env.REACT_APP_BUILD_TIME || '';
export const BUILD_BRANCH = process.env.REACT_APP_BUILD_BRANCH || '';

export const formatBuildLabel = () => (BUILD_VERSION === 'dev' ? 'dev' : BUILD_VERSION);

export const formatBuildTooltip = () => {
  const parts = [`Build ${BUILD_VERSION}`];
  if (BUILD_BRANCH) parts.push(BUILD_BRANCH);
  if (BUILD_TIME) {
    try {
      parts.push(new Date(BUILD_TIME).toLocaleString());
    } catch {
      parts.push(BUILD_TIME);
    }
  }
  return parts.join(' · ');
};
